export default {
    parseQueryStringParams(params){
        var paramsList=[]
        for(var key in params){
            var value=params[key];
            if(value===undefined || value==='undefined')
                continue
            paramsList.push(`${key}=${value}`);
        }
        return paramsList.join('&')
    },
    parseResourceWithQueryParams(url,params){
        var paramsString=this.parseQueryStringParams(params)
        return paramsString ? `${url}?${paramsString}` : url
    }
}